import axios from 'axios'

// 基础请求配置
const BASE_CONFIG = {
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
}

// 创建AI音频API实例
const aiAudioService = axios.create({
  baseURL: 'https://aiaudio.hqrhtech.com',
  timeout: 60000,
  ...BASE_CONFIG
})

// 创建问卷API实例
const surveyService = axios.create({
  baseURL: 'https://aiaudioios.hqrhtech.com',  // 恢复为HTTP，因为Android是正常的
  ...BASE_CONFIG
})

// 通用请求拦截器
const createRequestInterceptor = (serviceName) => (config) => {
  // 确保 headers 对象存在
  if (!config.headers) {
    config.headers = {}
  }

  // 自动检测 FormData：如果是 FormData，强制删除 Content-Type 让浏览器自动设置
  if (config.data instanceof FormData) {
    // 无论 Content-Type 是什么值（包括 null、undefined、字符串），都删除
    delete config.headers['Content-Type']
    delete config.headers['content-type'] // 兼容小写
    console.log(`[${serviceName}] 检测到 FormData，已删除 Content-Type，让浏览器自动设置`)
  }
  // 如果调用方显式设置了 Content-Type 为 null，删除它
  else if (config.headers['Content-Type'] === null || config.headers['content-type'] === null) {
    delete config.headers['Content-Type']
    delete config.headers['content-type']
  }
  // 如果调用方没有设置 Content-Type，使用默认 application/json
  else if (!('Content-Type' in config.headers) && !('content-type' in config.headers)) {
    config.headers['Content-Type'] = 'application/json'
  }
  
  console.log(`[${serviceName}] 发送请求:`, config.method?.toUpperCase(), config.url, 
    config.data instanceof FormData ? '(FormData)' : '')
  return config
}

// AI音频服务响应拦截器 - 处理问卷API的响应格式
const createAiAudioResponseInterceptor = (serviceName) => ({
  success: (response) => {
    console.log(`[${serviceName}] 响应:`, response)
    // AI音频服务可能返回直接的数据格式，不做额外处理
    return response
  },
  error: (error) => {
    return handleApiError(error, serviceName)
  }
})

// 问卷服务响应拦截器 - 处理 {code, data, msg} 格式
const createSurveyResponseInterceptor = (serviceName) => ({
  success: (response) => {
    console.log(`[${serviceName}] 响应:`, response)
    // 问卷服务返回 {code: 0, data: {...}, msg: ""} 格式
    // 直接返回，让上层业务逻辑处理
    return response
  },
  error: (error) => {
    return handleApiError(error, serviceName)
  }
})

// 统一的错误处理函数
const handleApiError = (error, serviceName) => {
  let message = '网络连接失败，请检查网络后重试'

  if (error.response) {
    const status = error.response.status
    switch (status) {
      case 400:
        message = '请求参数错误'
        break
      case 401:
        message = '未授权访问'
        break
      case 403:
        message = '禁止访问'
        break
      case 404:
        message = '请求的资源不存在'
        break
      case 500:
        message = '服务器内部错误'
        break
      case 502:
        message = '网关错误'
        break
      case 503:
        message = '服务暂不可用'
        break
      default:
        message = `请求失败 (${status})`
    }
  } else if (error.request) {
    message = '网络连接超时，请重试'
  }

  console.error(`[${serviceName}] API请求错误:`, error)
  const apiError = new Error(message)
  apiError.name = 'NetworkError'
  return Promise.reject(apiError)
}

// 配置AI音频服务拦截器
aiAudioService.interceptors.request.use(
  createRequestInterceptor('AI_AUDIO'),
  (error) => Promise.reject(error)
)

const aiAudioResponseInterceptor = createAiAudioResponseInterceptor('AI_AUDIO')
aiAudioService.interceptors.response.use(
  aiAudioResponseInterceptor.success,
  aiAudioResponseInterceptor.error
)

// 配置问卷服务拦截器（处理微信相关接口）
surveyService.interceptors.request.use(
  createRequestInterceptor('SURVEY'),
  (error) => Promise.reject(error)
)

const surveyResponseInterceptor = createSurveyResponseInterceptor('SURVEY')
surveyService.interceptors.response.use(
  surveyResponseInterceptor.success,
  surveyResponseInterceptor.error
)

// 导出服务实例
export { aiAudioService, surveyService }
